import { useSyncExternalStore } from 'react';
import { getIdentity, subscribeIdentity, type Identity } from './identity.js';

/**
 * Re-renders on identity change. `getIdentity` returns a stable reference
 * between writes, which is what `useSyncExternalStore` requires (and is also
 * why it doubles as the server snapshot).
 */
export function useIdentity(): Identity | null {
  return useSyncExternalStore(subscribeIdentity, getIdentity, getIdentity);
}
